const PALETTE = [
  ["#FF9933", "#7c3f0d"],
  ["#138808", "#0a4304"],
  ["#38BDF8", "#0c4a6e"],
  ["#A78BFA", "#4c1d95"],
  ["#EAB308", "#713f12"],
  ["#F43F5E", "#881337"],
];

function hash(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h << 5) - h + str.charCodeAt(i);
  return Math.abs(h);
}

export function Avatar({ seed = "?", alias = "", size = 44, className = "" }) {
  const key = seed || alias || "?";
  const [c1, c2] = PALETTE[hash(key) % PALETTE.length];
  const letters = (alias || key).replace(/[^a-zA-Z]/g, "").slice(0, 2).toUpperCase() || "DN";
  return (
    <div
      className={`shrink-0 grid place-items-center font-display font-bold text-white select-none ${className}`}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        borderRadius: 10,
        background: `linear-gradient(135deg, ${c1}, ${c2})`,
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.12)",
      }}
    >
      {letters}
    </div>
  );
}
